module.exports = __webpack_public_path__ + "img/钢木实验台.80bc2fe1.jpg";